export default __webpack_public_path__ + "static/Spring Illustration-6c8168e5157091dd11992a8c1197c750.png";